<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-flex xs12 style="margin-top: 20px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'h4' : 'h3'">Cabana Gracillis: aconchego para casais junto à natureza</p>
      </v-flex>

      <v-flex xs12 v-if="$vuetify.breakpoint.mdAndUp">
        <v-responsive :aspect-ratio="16 / 9" style="width: 100vw">
          <video autoplay muted loop playsinline style="width: 100%; height: 100%; object-fit: cover">
            <source v-bind:src="gracillis" type="video/mp4" />
          </video>
        </v-responsive>
      </v-flex>
      <v-flex xs12 v-if="$vuetify.breakpoint.smAndDown">
        <v-responsive :aspect-ratio="9 / 16" style="width: 100vw">
          <video autoplay muted loop playsinline style="width: 100%; height: 100%; object-fit: cover">
            <source v-bind:src="gracillisCel" type="video/mp4" />
          </video>
        </v-responsive>
      </v-flex>

      <v-flex xs12 style="margin-top: 20px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'" v-html="$store.state.gracillis"></p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    contato: { default: false }
  },
  data() {
    return {};
  },
  methods: {
    funcContato() {
      this.$emit("update:contato", true);
    }
  },
  computed: {
    gracillis() {
      return process.env.VUE_APP_URL_API + `arquivos/Gracillis.mp4`;
    },
    gracillisCel() {
      return process.env.VUE_APP_URL_API + `arquivos/GracillisCel.mp4`;
    }
  }
};
</script>
